"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimilarVoiceCategory = void 0;
exports.SimilarVoiceCategory = {
    Premade: "premade",
    Cloned: "cloned",
    Generated: "generated",
    Professional: "professional",
    Famous: "famous",
};
